import React, { useState } from "react";

const ImageUploader = ({ value, onChange, label }) => {
    const [preview, setPreview] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
    
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setPreview(previewUrl);
    
            onChange({
                ...value,
                // file: previewUrl,
                file, 
            });
        }
    };
    

    const handleAltTextChange = (e) => {
        onChange({
            ...value,
            alt: e.target.value,
        });
    };

    return (
        <div className="inputWrapper col-3 p-2">
            <label>{label}</label>
            <div className="image-preview">
                {preview && <img src={preview} alt={value?.alt || "Image Preview"} width="200px" height="200px" />}
            </div>
            <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={{ marginBottom: "8px" }}
            />
            <input
                type="text"
                value={value?.alt || ""}
                onChange={handleAltTextChange}
                placeholder="Alt Text"
            />
        </div>
    );
};

export default ImageUploader;